module.exports = __webpack_public_path__ + "img/just.d0dd5d4c.png";